import { useLayoutEffect, useRef } from 'react';

const MAX_ROWS = 20;

/** 행의 마지막 성공 결과에서 읽던 위치. 조건 편집·검색 실패는 같은 결과이고, 새 성공 응답은 별도 결과다. */
export default function useResultScroll({ memory, rowKey, result, bodies }) {
  const listRef = useRef(null);
  const currentRef = useRef(null);
  const data = result?.data;
  const key = result?.key;
  const page = result?.page ?? data?.page;
  const at = result?.at;

  useLayoutEffect(() => {
    const el = listRef.current;
    if (!el || !memory || rowKey == null || !data) return undefined;
    const previous = memory.get(rowKey);
    const same = previous && previous.data === data && previous.key === key && previous.page === page && previous.at === at;
    const entry = same ? previous : { data, key, page, at, top: 0 };
    memory.delete(rowKey);
    memory.set(rowKey, entry);
    while (memory.size > MAX_ROWS) memory.delete(memory.keys().next().value);
    const current = { entry, target: entry.top, el };
    currentRef.current = current;

    const restore = () => {
      if (current.target == null) return;
      el.scrollTop = current.target;
      // 이미지·수식이 아직 자리를 차지하지 못했다면 본문 크기가 늘어날 때 한 번 더 복원한다.
      if (Math.abs(el.scrollTop - current.target) < 1) current.target = null;
    };
    restore();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(restore);
    if (observer) {
      observer.observe(el);
      if (el.firstElementChild) observer.observe(el.firstElementChild);
    }
    return () => {
      observer?.disconnect();
      entry.top = current.target ?? el.scrollTop;
      if (currentRef.current === current) currentRef.current = null;
    };
  }, [memory, rowKey, data, key, page, at, bodies]);

  const onScroll = () => {
    const current = currentRef.current;
    if (current && current.target == null) current.entry.top = current.el.scrollTop;
  };
  const onUserScroll = () => {
    const current = currentRef.current;
    if (!current) return;
    current.target = null;
    current.entry.top = current.el.scrollTop;
  };
  return { ref: listRef, onScroll, onWheel: onUserScroll, onTouchStart: onUserScroll, onPointerDown: onUserScroll, onKeyDown: onUserScroll };
}
